/* eslint-disable */
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box, Card } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { ToastContainer, toast } from 'react-toastify';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Services';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import Delete from '@material-ui/icons/Delete';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorCancel: {
        backgroundColor: "red",
    },
    colorRecord: {
        backgroundColor: "green",
    },
    bold: {
        fontWeight: 600,
    },
    table: {
        minWidth: 1000
    }

}));

export default function OrderAllocationConfigurationAddEdit(props) {
    const classes = useStyles();
    const screenCode = 'ORDERALLOCATIONCONFIGURATION';
    const navigate = useNavigate();
    const [groupList, setGroupList] = useState([]);
    const [outletList, setoutletList] = useState([]);
    const [grades, setGrades] = useState([]);
    const [priority, setPriority] = useState([]);
    const [mappingArray, setMappingArray] = useState([]);
    const [canEdit, setCanEdit] = useState({
        editFactory: false
    });
    const [formData, setFormData] = useState({
        groupID: "0",
        outletID: "0",
        factoryCode: "",
        priority: "0",
        fillRate: 0,
        erimsOutletCode: "",
        gradeID: "0",
        factoryName: "",
        createdBy: "",
        isActive: true
    });
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: false,
        submitButtonName: "Add",
        pageName: "Add Order Allocation Configuration"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false
    });
    const SearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please select a Group').required('Group Required'),
        priority: Yup.number().min(1, 'Please select a Priority').required('Priority Required'),
        fillRate: Yup.string()
            .nullable()
            .required('Fill Rate Required')
            .matches(/^\d+(\.\d{1,2})?$/, 'Fill Rate must have at most 2 decimal places')
            .test('range', 'Fill Rate must be between 1 and 100', value => {
                const num = parseFloat(value);
                return num >= 1 && num <= 100;
            }),
        gradeID: Yup.number().min(1, 'Please select a Grade').required('Grade Required'),
    });
    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            outletID:formData.outletID,
            factoryCode: formData.factoryCode,
            erimsOutletCode: formData.erimsOutletCode,
            priority: formData.priority,
            fillRate: formData.fillRate,
            gradeID: formData.gradeID,
            factoryName: formData.factoryName,
            createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
            isActive: formData.isActive
        },
        validationSchema: SearchSchema,
        onSubmit: (values) => {
            trackPromise(AddData(values));
        }
    });
    const { errors, touched, setValues, handleSubmit, getFieldProps, values } = formik;
    const { orderAllocationConfigurationID } = useParams();
    let decrypted = 0;

    useEffect(() => {
        decrypted = AESDecryptionParam(orderAllocationConfigurationID);
        if (decrypted > 0) {
            setPageProps({
                ...pageProps,
                isEdit: true,
                submitButtonName: "Update",
                editingID: parseInt(decrypted),
                pageName: "Edit Order Allocation Configuration"
            })
            setCanEdit({
                ...canEdit,
                editFactory: true
            });
            GetorderAllocationConfigurationDataById(decrypted);
        }
    }, []);

    useEffect(() => {
        getPermissions(), GetAllGroups(), GetAllPriority();
    }, [])

    useEffect(() => {
        GetGradeByGroupID();
    }, [values.groupID]);

    useEffect(() => {
        GetOutletByGroupID();
    }, [values.groupID]);

    useEffect(() => {
        setMappingArray([]);
    }, [values.groupID]);

    useEffect(() => {
        setMappingArray([]);
    }, [values.groupID]);

    useEffect(() => {
        setMappingArray([]);
    }, [values.gradeID]);

    useEffect(() => {
        setMappingArray([]);
    }, [values.priority]);

    useEffect(() => {
        setMappingArray([]);
    }, [values.fillRate]);

    async function GetorderAllocationConfigurationDataById(orderAllocationConfigurationID) {
        if (canEdit != false) {
            let result = await services.GetorderAllocationConfigurationDataById(orderAllocationConfigurationID);
            setValues({
                groupID: result.groupID,
                outletID: result.outletID,
                priority: result.priority,
                fillRate: result.fillRate,
                gradeID: result.gradeID,
                isActive: result.isActive,
            })
        }
    }

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITORDERALLOCATIONCONFIGURATION');
        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });
        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        });
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetAllPriority() {
        var res = await services.GetAllPriority();
        if (res != null) {
            setPriority(res);
        }
    }

    async function GetGradeByGroupID() {
        var res = await services.GetGradeByGroupID(values.groupID);
        if (res != null) {
            setGrades(res);
        }
    }


    async function GetOutletByGroupID() {
        var res = await services.GetOutletByGroupID(values.groupID);
        if (res != null) {
            setoutletList(res);
        }
    }

    const onFillRateChange = (index, value) => {
        const updated = [...mappingArray];
        if (value === '') {
            updated[index].fillRate = null; 
        } else {
            const parsedValue = parseFloat(value);

            updated[index].fillRate = parsedValue;
        }
        setMappingArray(updated);
    };



    async function AddData() {

        const newMappings = [];
        if (pageProps.isEdit == true) {
            let decrypted = 0;
            decrypted = AESDecryptionParam(orderAllocationConfigurationID);
            let model = {
                orderAllocationConfigurationID: parseInt(decrypted),
                fillRate: parseFloat(values.fillRate),
                priority: values.priority,
                isActive: values.isActive,
                createdBy: parseInt(TokenDecoder.getUserIDFromToken())
            }
            let res = await services.UpdateOrderAllocationConfigurationData(model);
            if (res.statusCode === "Success") {
                toast.success("Order Allocation Configuration Updated Successfully");
                setTimeout(() => {
                    navigate('/dashboard/OrderAllocationConfiguration');
                }, 3000);
            }
        } else {
            const baseModel = {
                groupID: values.groupID,
                gradeID: values.gradeID,
                priority: values.priority,
                fillRate: parseFloat(values.fillRate)
            };

            const gradeAlreadyExists = mappingArray.some(item => item.gradeID === values.gradeID);
            if (gradeAlreadyExists) {
                toast.error("Grade already added to the List!");
                return;
            }
            var response = await services.GetExestingOrderAllocationConfigurationData(baseModel);
            if (response.statusCode == "Error") {
                toast.error(response.message);
                return;
            }
            let res = await services.GetFactoriesByGradeID(values.gradeID);
            if (res.length == 0) {
                toast.error("No Outlets were found for this grade!");
                return;
            }
            else {
                res.map((row, index) => (
                    newMappings.push({
                        ...baseModel,
                        outletID: row.factoryID,
                        outletCode: row.factoryCode,
                        outletName: row.factoryName,
                        groupName: groupList.find(x => x.groupID == values.groupID).groupName,
                        gradeName: grades.find(x => x.gradeID == values.gradeID).gradeName,
                        priorityName: priority.find(x => x.priorityID == values.priority).priorityName,
                        isActive: values.isActive,
                        createdBy: values.createdBy
                    })
                ));
            }
            if (newMappings.length > 0) {
                setMappingArray(prev => [...prev, ...newMappings]);
            }
        }
    }

    const DeleteDetails = (row) => {
        const updatedArray = mappingArray.filter(item => item !== row);
        setMappingArray(updatedArray);
    };

    async function SaveData() {
        for (const row of mappingArray) {
            if (isNaN(row.fillRate) || row.fillRate < 1 || row.fillRate > 100) {
                toast.error("Fill Rate must be between 1 and 100 for all entries.");
                return;
            }
        }
        if (mappingArray.length > 0) {
            var response = await services.SaveOrderAllocationConfigurationData(mappingArray);
            if (response.statusCode == "Success") {
                toast.success("Order Allocation Configuration Saved Successfully");
                setMappingArray([]);
            }
            else {
                toast.error(response.message);
            }
        }
    }

    function clearAll() {
        setValues({
            ...values,
            gradeID: 0,
            priority: 0,
            fillRate: "",
        })
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Add  Order Allocation Configuration |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/OrderAllocationConfiguration"}
                        btname="Back"
                        pageName={pageProps.pageName}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={(e) => {
                                            setValues({
                                                ...values,
                                                gradeID: "0",
                                            });
                                            formik.setFieldValue('groupID', e.target.value);
                                        }}
                                        disabled={pageProps.isEdit}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    {pageProps.isEdit == true &&
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Outlet *"
                                        value={formik.values.outletID}
                                        onChange={(e) => {
                                            formik.setFieldValue('outletID', e.target.value);
                                        }}
                                        disabled={pageProps.isEdit}
                                        error={Boolean(touched.outletID && errors.outletID)}
                                        helperText={touched.outletID && errors.outletID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Outlet</MenuItem>
                                        {outletList.map((option) => (
                                            <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                     }
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Grade *"
                                        value={formik.values.gradeID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('gradeID')}
                                        disabled={pageProps.isEdit}
                                        error={Boolean(touched.gradeID && errors.gradeID)}
                                        helperText={touched.gradeID && errors.gradeID}
                                    >
                                        <MenuItem key={0} value={0}>Select Grade</MenuItem>
                                        {grades.map((option) => (
                                            <MenuItem key={option.gradeID} value={option.gradeID}>
                                                {option.gradeName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Priority *"
                                        value={formik.values.priority}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('priority')}
                                        error={Boolean(touched.priority && errors.priority)}
                                        helperText={touched.priority && errors.priority}
                                    >
                                        <MenuItem key={0} value={0}>Select Priority</MenuItem>
                                        {priority.map((option) => (
                                            <MenuItem key={option.priorityID} value={option.priorityID}>
                                                {option.priorityName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Fill Rate % *"
                                        value={formik.values.fillRate}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('fillRate')}
                                        error={Boolean(touched.fillRate && errors.fillRate)}
                                        helperText={touched.fillRate && errors.fillRate}
                                    />
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                value={formik.values.isActive}
                                                checked={formik.values.isActive}
                                                {...getFieldProps('isActive')}
                                                onClick={formik.handleChange}
                                                color='error'
                                                name="isActive"
                                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                            />}
                                        label="Is Active"
                                    />
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    {/* <Button
                                        type="button"
                                        variant="outlined"
                                        color='error'
                                        disabled={pageProps.isEdit}
                                        onClick={() => clearAll()}
                                    > Clear</Button> */}
                                    <Button
                                        type="submit"
                                        variant="outlined"
                                        color='secondary'
                                    >{pageProps.submitButtonName}</Button>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    {mappingArray.length > 0 && (
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} style={{ marginTop: '20px' }}>
                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                <Paper className={classes.root}>
                                    <TableContainer sx={{ maxHeight: 440, borderRadius: 0 }}>
                                        <Table size="small" border='1px' stickyHeader aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" style={{ width: '20%' }}>Outlet Code</TableCell>
                                                    <TableCell align="left" style={{ width: '20%' }}>Outlet Name</TableCell>
                                                    <TableCell align="center" style={{ width: '20%' }}>Grade</TableCell>
                                                    <TableCell align="center" style={{ width: '20' }}>Priority</TableCell>
                                                    <TableCell align="center" style={{ width: '25%' }}>Fill Rate %</TableCell>
                                                    <TableCell align="center" style={{ width: '25%' }}>Actions</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {mappingArray.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell align="center" style={{ width: '25%' }}>{row.outletCode}</TableCell>
                                                        <TableCell align="left" style={{ width: '25%' }}>{row.outletName}</TableCell>
                                                        <TableCell align="center" style={{ width: '25%' }}>{row.gradeName}</TableCell>
                                                        <TableCell align="center" style={{ width: '25%' }}>{row.priorityName}</TableCell>
                                                        <TableCell align="center">
                                                            <TextField
                                                                size="small"
                                                                type="number"
                                                                variant="outlined"
                                                                value={row.fillRate === null || row.fillRate === undefined ? 0 : row.fillRate}
                                                                onChange={(e) => onFillRateChange(index, parseFloat(e.target.value))}
                                                                inputProps={{
                                                                    min: 1,
                                                                    max: 100,
                                                                    step: 0.01,
                                                                    style: { textAlign: 'right' },
                                                                }}
                                                                sx={{ width: '100px' }}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="center" style={{ width: '25%' }}>
                                                            <IconButton onClick={() => DeleteDetails(row)}>
                                                                <Delete color="error" />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Paper>
                            </Card>
                        </Stack>
                    )}
                    {(mappingArray.length > 0) ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="secondary"
                                type="button"
                                variant="outlined"
                                onClick={SaveData}
                            >
                                {"Save"}
                            </Button>
                        </Box>
                        : null}
                </Container>
            </Page>
        </>
    );
}

